import { render, staticRenderFns } from "./CreateVotesModal.vue?vue&type=template&id=5ca9ce42&scoped=true"
import script from "./CreateVotesModal.vue?vue&type=script&lang=js"
export * from "./CreateVotesModal.vue?vue&type=script&lang=js"
import style0 from "./CreateVotesModal.vue?vue&type=style&index=0&id=5ca9ce42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca9ce42",
  null
  
)

export default component.exports